import React, { Component } from 'react'
import styled from 'styled-components'

import PropTypes from 'prop-types'

import { above, below } from '../style/functions'
import Button from './button'
import carat from '../images/carat.svg'

const priceRangeOptions = [
	{ key: '', value: 'ご希望価格帯' },
	{ key: '$2,000,000+', value: '$2,000,000+' },
	{ key: '$1,500,000 - $2,000,000', value: '$1,500,000 - $2,000,000' },
	{ key: '$1,200,000 - $1,500,000', value: '$1,200,000 - $1,500,000' },
	{ key: '$1,000,000 - $1,200,000', value: '$1,000,000 - $1,200,000' },
	{ key: '$900,000 - $1,000,000', value: '$900,000 - $1,000,000' },
	{ key: '$800,000 - $900,000', value: '$800,000 - $900,000' },
	{ key: '$700,000 - $800,000', value: '$700,000 - $800,000' },
	// { key: '$600,000 - $700,000', value: '$600,000 - $700,000' },
]

const numberOfBedroomsOptions = [
	{ key: '', value: 'ベッドルーム数' },
	{ key: 'Studio', value: 'スタジオ' },
	{ key: '1 Bedroom', value: '1ベッドルーム' },
	{ key: '1 Bedroom + Study', value: '書斎付き1ベッドルーム' },
	{ key: '2 Bedroom', value: '2ベッドルーム' },
	{ key: '2 Bedroom + Study', value: '書斎付き2ベッドルーム' },
	{ key: '3 Bedroom', value: '3ベッドルーム' },
	{ key: '3 Bedroom + Study', value: '書斎付き2ベッドルーム' },
	{ key: 'Penthouse', value: 'ペントハウス' },
	{ key: 'CommercialorRetail', value: '小売/商業' },
]

// const hearAboutUsOptions = [
//   { key: "", value: "Crownグループを何で知りましたか？*" },
//   { key: "SMH", value: "Sydney Morning Herald紙" },
//   { key: "Wechat", value: "Wechat" },
//   { key: "Realestate.com.au", value: "Realestate.com.au" },
//   { key: "Ethnic Papers", value: "エスニックコミュニティー紙" },
//   { key: "Wentworth courier", value: "Wentworth courier" },
//   { key: "Southern courier", value: "Southern courier" },
//   { key: "Inner West Courier", value: "Inner West Courier" },
//   { key: "Facebook", value: "フェイスブック" },
//   { key: "Instagram", value: "インスタグラム" },
//   { key: "Website", value: "ウェブサイト" },
//   { key: "Apartments Developments", value: "Apartments Developments" },
//   { key: "Domain", value: "Domain" },
//   { key: "Starts Coop", value: "スターツコーポレーション㈱ HP" },
//   { key: "Mitsubishi", value: "三菱地所レジデンスクラブメール" },
//   { key: "Other", value: "その他" }
// ];

const buyerTypeOptions = [
	{ key: '', value: '住宅購入者 種類*' },
	{ key: 'INV', value: '出資者' },
	{ key: 'FHB', value: '最初の住宅購入者' },
	{ key: 'O/O', value: 'その後の住宅購入者' },
	{ key: 'Downsizer', value: 'ダウンサイザー' },
]

const countryOptions = [
	{ key: '', value: '国*' },
	{ key: 'Australia', value: 'オーストラリア' },
	{ key: 'China', value: '中国' },
	{ key: 'China – Hong Kong', value: '中国-香港' },
	{ key: 'India', value: 'インド' },
	{ key: 'Indonesia', value: 'インドネシア' },
	{ key: 'Japan', value: '日本' },
	{ key: 'Malaysia', value: 'マレーシア' },
	{ key: 'Philippines', value: 'フィリピン' },
	{ key: 'Singapore', value: 'シンガポール' },
	{ key: 'United Kingdom', value: 'イギリス' },
	{ key: 'United States', value: 'アメリカ' },
	{ key: 'Vietnam', value: 'ベトナム' },
	{ key: 'Other', value: 'その他' },
]

const submissionStatuses = {
	success: 'Your enquiry has been submitted.',
	failed: 'Unable to send enquiry at this time - please try again later.',
}

class EnquiryForm extends Component {
	constructor(props) {
		super(props)
		this.state = {
			first_name: '',
			last_name: '',
			email: '',

			priceRange: '',
			numberOfBedrooms: '',
			hearAboutUs: '',
			buyerType: '',
			zip: '',
			country: '',
			error: {},
			submissionStatus: '',
		}
	}

	handleSubmit(e) {
		const { to } = this.props

		const utm_source = this.props.utm_source ? this.props.utm_source : ''
		const utm_campaign = this.props.utm_campaign ? this.props.utm_campaign : ''
		const utm_medium = this.props.utm_medium ? this.props.utm_medium : ''
		const _utm_content = this.props.utm_source || this.props.utm_campaign || this.props.utm_medium ? utm_source + ' ' + utm_medium + ' ' + utm_campaign : '';

		// salesforce hardcoded (salesforce is not used for new One Mastery site).
		// declared in  json mapping
		// const Campaign_ID = '70190000001nyLH'
		// const oid = '00D90000000cpQH'
		// const retURL = 'https://onemastery.com.au/#enquiry'
		// const debug = '1'
		// const debugEmail = 'ruben@efront.com.au'

		const {
			first_name,
			last_name,
			email,
			mobile,
			priceRange,
			hearAboutUs,
			numberOfBedrooms,
			buyerType,
			zip,
			country,
		} = this.state

		// const salesforceArray = {
		// 	Campaign_ID: Campaign_ID,
		// 	oid: oid,
		// 	retURL: retURL,
		// 	// debug: debug,
		// 	// debugEmail: debugEmail,
		// 	first_name: first_name,
		// 	last_name: last_name,
		// 	email: email,
		// 	mobile: mobile,
		// 	'00N9000000384oT': priceRange,
		// 	'00N9000000384oS': numberOfBedrooms,
		// 	'00N90000005zUtt': buyerType,
		// 	zip: zip,
		// 	'00N0o00000NMzzW': zip,
		// 	country: country,
		// 	'00N0o00000NMzzR': country,
		// 	'00N0o00000NdgQ3': utm_source,
		// 	'00N0o00000NMzmc': utm_medium,
		// 	'00N0o00000NMzmh': utm_campaign,
		// 	'00N0o00000NMzmm': _utm_content,
		// 	'00N0o00000NdgQ8': _utm_content,
		// }

		const values = {
			first_name,
			last_name,
			email,
			mobile,
			priceRange,
			hearAboutUs,
			numberOfBedrooms,
			buyerType,
			zip,
			country,
			utm_source,
			utm_campaign,
			utm_medium,
			_utm_content,
			// salesforceArray,
		}

		if (!this.validateForm()) {
			setTimeout(() => console.log(this.state.error), 1000)
			return false
		}

		fetch(to, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(values), // Doesn't send to Salesforce like the original site did (Mastery by Crown Group).
		})
			.then((res) => res.json())
			.then((json) => {
				if (json.errorMessage) {
					this.setState({ ...this.state, submissionStatus: 'failed' })
				} else {
					this.setState({ ...this.state, submissionStatus: 'success' })
				}
			})
			.catch((err) => this.setState({ ...this.state, submissionStatus: 'success' }))

		e.preventDefault()
	}

	onInputChange(e) {
		const name = e.target.name
		this.setState({ ...this.state, [name]: e.target.value })
	}

	validateForm() {
		const {
			first_name,
			last_name,
			email,
			mobile,
			priceRange,
			hearAboutUs,
			numberOfBedrooms,
			buyerType,
			zip,
			country,
		} = this.state
		let error = { ...this.state.error }
		let isValid = true
		if (!first_name) {
			error['first_name'] = '必須項目です'
			isValid = false
		} else {
			error['first_name'] = ''
		}

		if (!last_name) {
			error['last_name'] = '必須項目です'
			isValid = false
		} else {
			error['last_name'] = ''
		}

		// if (!priceRange) {
		// 	error['priceRange'] = '必須項目です'
		// 	isValid = false
		// } else {
		// 	error['priceRange'] = ''
		// }

		if (!email || !this.validateEmail(email)) {
			error['email'] = '有効なメールアドレスではありません'
			isValid = false
		} else {
			error['email'] = ''
		}

		if (!mobile || !this.validateContactNumber(mobile)) {
			error['mobile'] = '有効な電話番号ではありません'
			isValid = false
		} else {
			error['mobile'] = ''
		}

		// if (!numberOfBedrooms || numberOfBedrooms === numberOfBedroomsOptions[0].value) {
		// 	error['numberOfBedrooms'] = '選択肢から選んでください'
		// 	isValid = false
		// } else {
		// 	error['numberOfBedrooms'] = ''
		// }

		// if (!hearAboutUs || hearAboutUs === hearAboutUsOptions[0].value) {
		//   error["hearAboutUs"] = "選択肢から選んでください";
		//   isValid = false;
		// } else {
		//   error["hearAboutUs"] = "";
		// }

		if (!buyerType || buyerType === buyerTypeOptions[0].value) {
			error["buyerType"] = "選択肢から選んでください";
			isValid = false;
		} else {
			error["buyerType"] = "";
		}

		if (!country || country === countryOptions[0].value) {
			error["country"] = "選択肢から選んでください";
			isValid = false;
		} else {
			error["country"] = "";
		}

		if (!zip) {
			error["zip"] = "必須項目です";
			isValid = false;
		} else {
			error["zip"] = "";
		}

		this.setState({
			...this.state,
			error,
		})

		return isValid
	}

	validateEmail(email) {
		var re = /(.+)@(.+){2,}\.(.+){2,}/
		return re.test(String(email).toLowerCase())
	}

	validateContactNumber(value) {
		return value.match(/\d/g).length === 15
	}

	render() {
		const { error, submissionStatus } = this.state
		const form = (
			<div className='form'>
				<div className='field'>
					<input
						name='last_name'
						type='text'
						placeholder='お名前（姓*'
						onChange={this.onInputChange.bind(this)}
					/>
					{error.last_name && <span className='error-text'>{error.last_name}</span>}
				</div>
				<div className='field'>
					<input
						name='first_name'
						type='text'
						placeholder='お名前（名*'
						onChange={this.onInputChange.bind(this)}
					/>
					{error.first_name && <span className='error-text'>{error.first_name}</span>}
				</div>
				<div className='field'>
					<input
						name='email'
						type='text'
						placeholder='Eメールアドレス*'
						onChange={this.onInputChange.bind(this)}
					/>
					{error.email && <span className='error-text'>{error.email}</span>}
				</div>
				<div className='field'>
					<input
						name='mobile'
						type='tel'
						placeholder='携帯電話番号*'
						onChange={this.onInputChange.bind(this)}
					/>
					{error.mobile && <span className='error-text'>{error.mobile}</span>}
				</div>
				<div className='field select-field'>
					<select
						name='priceRange'
						value={this.state.priceRange}
						onChange={this.onInputChange.bind(this)}
					>
						{priceRangeOptions.map((option) => (
							<option key={option.key} value={option.key}>
								{option.value}
							</option>
						))}
					</select>
					{error.priceRange && <span className='error-text'>{error.priceRange}</span>}
				</div>
				<div className='field select-field'>
					<select
						name='numberOfBedrooms'
						value={this.state.numberOfBedrooms}
						onChange={this.onInputChange.bind(this)}
					>
						{numberOfBedroomsOptions.map((option) => (
							<option key={option.key} value={option.key}>
								{option.value}
							</option>
						))}
					</select>
					{error.numberOfBedrooms && (
						<span className='error-text'>{error.numberOfBedrooms}</span>
					)}
				</div>
				{/* <div className="field select-field full">
				<select
					name="hearAboutUs"
					value={this.state.hearAboutUs}
					onChange={this.onInputChange.bind(this)}
				>
					{hearAboutUsOptions.map(option => (
					<option key={option.key} value={option.key}>{option.value}</option>
					))}
				</select>
				{error.hearAboutUs && <span className="error-text">{error.hearAboutUs}</span>}
				</div> */}

				<div className='field select-field'>
					<select
						name='country'
						value={this.state.country}
						onChange={this.onInputChange.bind(this)}
					>
						{countryOptions.map((option) => (
							<option key={option.key} value={option.key}>
								{option.value}
							</option>
						))}
					</select>
					{error.country && <span className='error-text'>{error.country}</span>}
				</div>

				<div className='field'>
					<input
						name='zip'
						type='text'
						placeholder='郵便番号*'
						onChange={this.onInputChange.bind(this)}
					/>
					{error.zip && <span className='error-text'>{error.zip}</span>}
				</div>

				<div className='field select-field'>
					<select
						name='buyerType'
						value={this.state.buyerType}
						onChange={this.onInputChange.bind(this)}
					>
						{buyerTypeOptions.map((option) => (
							<option key={option.key} value={option.key}>
								{option.value}
							</option>
						))}
					</select>
					{error.buyerType && <span className='error-text'>{error.buyerType}</span>}
				</div>

				<div className='footer'>
					<Button onClick={this.handleSubmit.bind(this)}>登録する</Button>
					<input name='utm_campaign' type='hidden' value={this.props.utm_campaign} />
					<input name='utm_source' type='hidden' value={this.props.utm_source} />
					<input name='utm_medium' type='hidden' value={this.props.utm_medium} />
				</div>
			</div>
		)

		return (
			<EnquiryFormWrapper id='enquiry'>
				<h2>登録</h2>
				<hr />
				{(!submissionStatus || submissionStatus === 'failed') && (
					<React.Fragment>
						<p className='h3'>
							以下のフォームにご入力ください。折り返しご連絡をさせて頂きます。
						</p>
						{form}
					</React.Fragment>
				)}
				{submissionStatus === 'failed' && <p>{submissionStatuses.failed}</p>}
				{submissionStatus === 'success' && (
					<p className='status--success'>{submissionStatuses.success}</p>
				)}
			</EnquiryFormWrapper>
		)
	}
}

const EnquiryFormWrapper = styled.div`
	background: #f0f0f0;
	padding: 5rem 12%;

	h2 {
		text-align: center;
		text-transform: uppercase;
		font-style: normal;
		padding: 0;
	}

	hr {
		margin: 1.75rem auto;
	}

	p {
		text-align: center;
	}

	.footer {
		flex: 0 0 100%;
		text-align: center;
		margin: 2rem 0 0;
	}

	.form {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		margin: 0 auto;
		max-width: 108rem;
	}

	.field {
		${above.tablet`
      float: left;
      width: 50%;

      :nth-child(odd) {
        float: left;
        padding-right: 0.5rem;

        &.select-field:after {
          right: 1.5rem;
        }
      }
      :nth-child(even) {
        float: right;
        padding-left: 0.5rem;
      }
    `}

		margin-bottom: 30px;

		&.full {
			width: 100%;
			padding: 0;

			&.select-field:after {
				right: 1rem;
			}
		}
	}

	.select-field {
		position: relative;

		:after {
			content: '';
			background: url(${carat}) no-repeat 50% 50%;
			background-size: contain;
			height: 1em;
			width: 1em;
			position: absolute;
			top: 1.5em;
			right: 1rem;
			margin-top: -0.5em;
		}
	}

	input,
	select {
		width: 100%;
		background: transparent;
		border-bottom: 1px solid currentColor;
		font-family: inherit;
		font-size: inherit;
		letter-spacing: inherit;
		color: inherit;
		text-transform: uppercase;
		height: 3rem;
		line-height: 3rem;
		opacity: 1;

		::placeholder {
			/* Chrome, Firefox, Opera, Safari 10.1+ */
			color: inherit;
			opacity: 1; /* Firefox */
		}

		:-ms-input-placeholder {
			/* Internet Explorer 10-11 */
			color: inherit;
		}

		::-ms-input-placeholder {
			/* Microsoft Edge */
			color: inherit;
		}
	}

	select {
		border-radius: 0px;
		-webkit-border-radius: 0px;
		-webkit-appearance: none;
		-moz-appearance: none;
		::-ms-expand {
			display: none;
		}
		background: transparent;
		background-repeat: no-repeat;
		background-position-x: 100%;
		background-position-y: -5px;
	}
	.error-text {
		color: #b96a51;
		font-size: 9pt;
		position: relative;
		top: 8px;
	}

	${below.tablet`
  .form {
    margin:0;
    > div{
      flex: 0 100%;
      input,
      select {
        width: 100%;
    }
  }
		`};
`

EnquiryForm.propTypes = {
	background: PropTypes.string,
	color: PropTypes.string,
	to: PropTypes.string.isRequired,
}

EnquiryForm.defaultProps = {
	background: '#0E434B',
	color: '#FFFFFF',
}

export default EnquiryForm
